import { makeStyles } from '@mui/styles';
import { colors } from '../../../../../colors';

export const useStyles = makeStyles(() => ({
  // Container styles
  container: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: colors.neutral0,
    borderRadius: '12px',
    border: `1px solid ${colors.neutral200}`,
  },
  sectionContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  sectionHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderBottom: `1px solid ${colors.neutral200}`,
    padding: '24px',
  },
  sectionTitle: {
    fontSize: '18px',
    fontWeight: 600,
    lineHeight: '24px',
    color: colors.neutral900,
  },
  sectionBody: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },

  // Action links
  viewReasoningLink: {
    fontSize: '14px',
    fontWeight: 700,
    lineHeight: '20px',
    color: colors.primary600,
    cursor: 'pointer',
    '&:hover': {
      color: colors.primary400,
    },
  },
  editLink: {
    fontSize: '14px',
    fontWeight: 600,
    lineHeight: '20px',
    color: colors.primary600,
    cursor: 'pointer',
    '&:hover': {
      color: colors.primary700,
      textDecoration: 'underline',
    },
  },

  // Problem step
  problemTextArea: {
    padding: '24px',
    '& .MuiOutlinedInput-root': {
      fontSize: '14px',
      lineHeight: '20px',
      color: colors.neutral900,
      '& fieldset': {
        borderColor: colors.neutral300,
      },
      '&:hover fieldset': {
        borderColor: colors.neutral400,
      },
      '&.Mui-focused fieldset': {
        borderColor: colors.primary600,
      },
    },
  },
  // Text field
  textField: {
    '& .MuiOutlinedInput-root': {
      fontSize: '14px',
      lineHeight: '20px',
      color: colors.neutral900,
      backgroundColor: colors.neutral0,
      '& fieldset': {
        borderColor: colors.neutral300,
      },
      '&:hover fieldset': {
        borderColor: colors.neutral400,
      },
      '&.Mui-focused fieldset': {
        borderColor: colors.primary600,
      },
    },
  },

  // Goals step
  outlinedBtn: {
    color: colors.primary600,
    borderColor: colors.primary300,
    backgroundColor: colors.white,
    fontWeight: 700,
    fontSize: 16,
    lineHeight: '24px',
    '&:hover': {
      backgroundColor: colors.primary50,
    },
  },
  goalCard: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    padding: '24px',
    backgroundColor: colors.neutral25,
    border: `1px solid ${colors.neutral200}`,
    borderRadius: '8px',
    transition: 'all 0.2s ease',
  },
  goalCardSelected: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    padding: '24px',
    backgroundColor: colors.primary50,
    border: `2px solid ${colors.primary500}`,
    borderRadius: '8px',
    transition: 'all 0.2s ease',
  },
  goalCardContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  goalName: {
    fontSize: '18px',
    fontWeight: 600,
    lineHeight: '28px',
    color: colors.neutral900,
  },
  goalDetails: {
    fontSize: '16px',
    lineHeight: '24px',
    fontWeight: 500,
    color: colors.neutral500,
  },
  expectedCompletion: {
    fontSize: '16px',
    lineHeight: '24px',
    fontWeight: 500,
    color: colors.neutral500,
  },
  goalCardActions: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: '8px',
  },
  primaryBtn:{
    whiteSpace: 'nowrap',
    color: colors.white,
    padding: '12px 20px',
  },

  // Objectives step
  objectiveGoalCard: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    padding: '24px',
    border: `1px solid ${colors.neutral200}`,
    borderRadius: '8px',
  },
  objectiveGoalHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    gap: '16px',
  },
  objectivesLabel: {
    fontSize: '16px',
    fontWeight: 500,
    lineHeight: '24px',
    color: colors.neutral800,
  },
  objectiveItem: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '12px',
    padding: '24px 16px',
    backgroundColor: colors.neutral25,
    border: `1px solid ${colors.neutral200}`,
    borderRadius: '8px',
  },
  objectiveItemSelected: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '12px',
    padding: '24px 16px',
    backgroundColor: colors.primary50,
    border: `2px solid ${colors.primary500}`,
    borderRadius: '8px',
  },
  objectiveCheckbox: {
    padding: '0',
    '&.Mui-checked': {
      color: colors.primary600,
    },
  },
  objectiveText: {
    flex: 1,
    fontSize: '14px',
    lineHeight: '20px',
    color: colors.neutral900,
  },
  editIcon: {
    width: '20px',
    height: '20px',
    color: colors.neutral500,
    cursor: 'pointer',
    '&:hover': {
      color: colors.primary600,
    },
  },
  // Icon button
  iconButton: {
    width: '24px',
    height: '24px',
    cursor: 'pointer',
    color: colors.primary600,
    '&:hover': {
      color: colors.primary400,
    },
  },
}));

